// Helpers for the organizer forms (users/events/*, users/races/_form, users/organizers/_form)
import $ from 'jquery';

// Compares a form with the serializeArray() taken on page load (the CSRF token is ignored)
function unchanged($form, oldData) {
  const data = $form.serializeArray();

  if (data.length !== oldData.length) {
    return false;
  }
  return data.every((item, index) => item.name === 'authenticity_token' || item.value === oldData[index].value);
}

// .js-disable-submit-btn: the submit buttons stay disabled until the form changed
function disableSubmitUntilChanged() {
  $('.js-disable-submit-btn')
    .each(function () {
      $(this).data('serialized', $(this).serializeArray());
    })
    .on('change input', function (e) {
      const $form = $(this);
      const changed = (e.target.type === 'file' && e.target.value !== '') ||
        !unchanged($form, $form.data('serialized'));

      $form.find('input:submit, button:submit').prop('disabled', !changed);
    })
    .find('input:submit, button:submit')
    .prop('disabled', true);
}

// "Save and continue" submits with the next step's path (data-alternative) as redirect_to
function saveAndContinue() {
  $('#save_and_continue').on('click', function (e) {
    e.preventDefault();
    const $input = $('#redirect_to');
    $input.val($input.data('alternative'));
    $(this).closest('form').trigger('submit');
  });
}

// Buttons that show and hide the translated name/teaser/description fields
function translationToggles() {
  [
    ['name_translation_button', 'name_translation_fields'],
    ['teaser_translation_button', 'teaser_translation_fields'],
    ['race_name_translation_button', 'race_name_translation_fields'],
    ['race_description_translation_button', 'race_description_translation_fields'],
  ].forEach(([buttonId, fieldsId]) => {
    const button = document.getElementById(buttonId);
    const fields = document.getElementById(fieldsId);

    if (button && fields) {
      button.addEventListener('click', () => fields.classList.toggle('hidden'));
    }
  });
}

// Event form: labels, logo and header image need a run trophy category above 1
function categorySelect() {
  const select = document.getElementById('category_select');
  if (!select) {
    return;
  }

  const update = () => {
    const enabled = Number(select.value) > 1;
    const labels = document.getElementById('labels_input');

    if (labels) {
      labels.classList.toggle('overlay', !enabled);
    }
    ['logo_upload', 'header_upload'].forEach((id) => {
      const input = document.getElementById(id);
      if (input) {
        input.disabled = !enabled;
      }
    });
  };

  update();
  select.addEventListener('change', update);
}

$(() => {
  translationToggles();
  categorySelect();
  disableSubmitUntilChanged();
  saveAndContinue();
});
